import React, { useState, useEffect } from "react";
import "./about.css";
import staff1 from "./staff2.jpeg"
import agent from './agent.png'
import agreement from './agreement.png'
import management from './management.png'
// import "animate.css/animate.min.css";
// import { AnimationOnScroll } from 'react-animation-on-scroll';
import { Link } from "react-router-dom";
import { collection, onSnapshot } from "firebase/firestore";
import { db } from "../firebase";
import { motion } from "framer-motion"
import Avatar from '@mui/material/Avatar';
import Stack from '@mui/material/Stack';

export default function About() {
  window.scrollTo(0, 0);
  const [feedback, setFeedback] = useState([]);

  useEffect(
    () => 
    onSnapshot(collection(db, 'feedback'), (snapshot) => 
    setFeedback(snapshot.docs.map((doc) => ({...doc.data(), id: doc.id})))
    ),
   [])


   function stringToColor(string) {
    let hash = 0;
    let i;
  
    /* eslint-disable no-bitwise */
    for (i = 0; i < string.length; i += 1) {
      hash = string.charCodeAt(i) + ((hash << 5) - hash);
    }
  
    let color = '#';
  
    for (i = 0; i < 3; i += 1) {
      const value = (hash >> (i * 8)) & 0xff;
      color += `00${value.toString(16)}`.slice(-2);
    }
    /* eslint-enable no-bitwise */
  
    return color;
  }
  function stringAvatar(name) {
    return {
      sx: {
        bgcolor: stringToColor(name),
      },
      children: `${name.split(' ')[0][0]}${name.split(' ')[1][0]}`,
    };
  }

  return (
    <div className="allabout">
        <motion.div
    initial={{ opacity: 0 }}
    animate={{ opacity: 1 }}
    exit={{ opacity: 0 }}
    transition={{ duration: 1 }}
    >
      <div className="aboutus">
        <div className="about">
          <h1>About Us</h1>
          <p>
            House hunting service is one of the main services we offer apart
            from property management and land brokerage corporate bodies or
            individuals.
          </p>
          <p>
            We provide professional property management services to aspiring
            property owners, either corporate bodies or individuals on issues
            regarding; Real Estate Management, Property Brokerage, Property
            Marketing /Acquisition and Real Estate Consultants.
          </p>
        </div>
      </div>

      <div className="more">
        <div className="staff">
          <h1>The Staff</h1>
          
        </div>
        
      </div>
      <div className="thestaff">
          <img src={staff1} alt="" />
      <p>
            Paragon Home Solutions is a Property Management company that
            was founded in 2021, with the aim of providing Real Estate Solutions
            and managing properties in the highest quality and standards.  We are a fully registered business under kenyan law to earn our clients' trust
            Paragon focuses on managing and financing commercial and
            residential, office, and business park properties around three major
            Towns in Kenya. These are Nairobi, Kisii, and Meru. In Nairobi, we
            offer House hunting and property management services in Parklands,
            Westlands, Ngara, along Thika Super Highway (Kasarani, Ruiru,
            Roysambu, Githurai, Ruai, Kahawa, Wendani) among other areas.
          </p>
          <p>
            In Kisii, we offer our services around Kisii Town, around Kisii
            University main Campus, Milimani, Nyanchwa, and Daraja. In Meru, we
            serve around Nkubu Town, Kariene, Meru Town and Makutano area We
            focus on Managing and operating properties that can benefit from our
            market knowledge and intensive operational skills with a focus on
            increasing their profitability and value.
          </p>
          <p>
            We provide professional property management services to aspiring
            property owners, either corporate bodies or individuals on issues
            regarding; Real Estate Management, Property Marketing /Acquisition
            and Real Estate Consultants.
          </p>

          <p>
            Our expertise also covers property brokerage, negotiating and
            structuring joint venture investments, property development
            analysis, and project management. Paragon is an emerging leader in
            the real estate industry. Our competitive edge is our competitive
            service delivery style, as well as our team of seasoned
            professionals united by a firm resolve to deliver. At Paragon
            Home Properties, “Your Satisfaction is Our Pride!”
          </p>
          </div>
          <hr style={{opacity: 0.5, marginLeft: "5%", marginRight: "5%"}}/>

          <div className="story">
          <h1><strong>STORY OF PARAGON HOMES SOLUTIONS</strong></h1>
          <p>Paragon Homes Solutions was founded by Jefferson Munene K, a seasoned real estate professional with a passion for helping people find their dream homes. After years of working in the industry, Jefferson saw a need for a more personalized and dedicated approach to real estate services, and Paragon Homes Solutions was born.
            </p>
<p>
Starting as a small operation, Paragon Homes Solutions quickly gained a reputation for providing exceptional service to clients. Our agents took the time to understand each client's unique needs and goals and went above and beyond to help them achieve their dreams. As word of our success spread, the business grew, and we became one of the leading real estate agencies in Kisii County, Kenya.
</p>
<p>
Despite our growth, our commitment to providing top-notch service has never wavered. Today, Paragon Homes Solutions is a full-service real estate agency with a team of experienced and knowledgeable agents, ready to help clients with all their real estate needs. Whether you're buying, selling, Renting or investing in property, we have the expertise and resources to guide you every step of the way.
</p>
<p>
At Paragon Homes Solutions, we are more than just a real estate agency - we are a family. Our agents work together to ensure that each client receives the best possible experience, and we are proud to have built lasting relationships with so many of our clients. We believe that buying or selling a home should be an exciting and stress-free experience, and we are dedicated to making that a reality for every client we serve.</p>
</div>

<hr style={{opacity: 0.5, marginLeft: "5%", marginRight: "5%"}}/>
<div className="testimonial-title">
<h1><strong>TESTIMONIALS</strong></h1></div>
          <div className="testimonials">
          {
  feedback
    .sort((a, b) => b.time - a.time) // Sort the feedback array in descending order by time
    .slice(0, 10) // Take the first 10 items from the sorted array
    .map((feedback, index) => {
      return (
        <figure class="snip1157">
          <blockquote>{feedback.feedback}
            <div class="arrow"></div>
          </blockquote>
          {/* <img src= {newLogo} alt="sq-sample17" /> */}
          <div className="initials">
          <Stack direction="row" spacing={1} alignItems="center">
            <Avatar {...stringAvatar(feedback.name)}/>
            {/* <Typography variant="body2" color="textSecondary">{feedback.name}</Typography> */}
          </Stack>
          </div>
          <div class="author">
            <h5>{feedback.name}<span> {feedback.email}</span></h5>
          </div>
        </figure>
      )
    })
}
 
          </div>
<hr style={{opacity: 0.5, marginLeft: "5%", marginRight: "5%"}}/>

<div className="services">
  <div className="title">
  <h1>OUR SERVICES</h1>
  </div>

  <div className="allservices">
<div className="service1">
  <div className="icon">
    <img src={agreement} alt="estate agent" />
  </div>
  <h2>Estate Agency</h2>
  <p>We have vast experiences in selling all kinds of property for years i.e. commercial, industrial, residential homes and Land</p>
  <Link to="/estate-agency">
  <h3  style={{cursor: "pointer"}}>&gt;&gt;Read More&lt;&lt;</h3>
  </Link>
</div>
<div className="service1">
  <div className="icon">
    <img src={management} alt="estate agent" />
  </div>
  <h2>Property Management</h2>
  <p>We strongly believe that property management resolves around extending the life of a property and its fittings thus enhancing its value and reducing operational costs.</p>
  <Link to="/property-management">
  <h3  style={{cursor: "pointer"}}>&gt;&gt;Read More&lt;&lt;</h3>
  </Link>
</div>
<div className="service1">
  <div className="icon">
    <img src={agent} alt="estate agent" />
  </div>
  <h2>Property Letting</h2>
  <p>We have vast experiences in selling all kinds of property for years i.e. commercial, industrial, residential homes and Land</p>
<Link 
to="/property-letting"
>
  <h3 style={{cursor: "pointer"}}>&gt;&gt;Read More&lt;&lt;</h3></Link>
</div>
</div>
</div>
</motion.div>
    </div>
  
  );
}
